import { passcodes } from './passcodes'

export const generatePasscode = () => {
  const firstWord: string = passcodes[getRandomInt(0, passcodes.length - 1)].toLowerCase()
  const secondWord: string = passcodes[getRandomInt(0, passcodes.length - 1)].toLowerCase()
  const thirdWord: string = passcodes[getRandomInt(0, passcodes.length - 1)].toLowerCase()

  return `${firstWord}-${secondWord}-${thirdWord}`
}

const getRandomInt = (min: number, max: number): number => {
  // Create byte array and fill with 1 random number
  var byteArray = new Uint32Array(1)
  window.crypto.getRandomValues(byteArray)

  // Convert to decimal
  var randomNum: any = '0.' + byteArray[0].toString()

  // Get number in range
  randomNum = Math.floor(randomNum * (max - min + 1)) + min

  return randomNum
}
